import homeBanner1 from "./ni/home-banner1.webp";
import homeBanner2 from "./ni/home-banner2.webp";
import hajjInnerBanner from "./ni/hajj-inner-banner.jpg";
import hajjInnerBanner2 from "./ni/hajj-inner-banner2.jpg";
import hajjInnerBanner3 from "./ni/hajj-inner-banner3.jpg";
import hajjInnerBanner4 from "./ni/hajj-inner-banner4.jpg";
import InnerBanner from "./ni/inner-banner.jpg";
// import hajjP1 from "./ni/hajj-p1.jpg";
import hajjP1 from "./ni/2.jpg";
import hajjP2 from "../hajj-2025/Package-2-17-18D.webp";
import hajjP3 from "../hajj-2025/Package-3-17D.webp";
import hajjP4 from "../hajj-2025/Package-4-14-15D.webp";
import hajjP5 from "../hajj-2025/Package-5-14D-Signature.webp";
import hajjP6 from "../hajj-2025/Package-6-14D-Pearl.webp";
import hajjP7 from "../hajj-2025/Package-7-14D.webp";
import hajjP8 from "../hajj-2025/Package-8-10-11D.webp";
import hajjP1MaktabB from "../hajj-2025-maktab-B/Polani Hajj Maktab B -1.webp";
import hajjP2MaktabB from "../hajj-2025-maktab-B/Polani Hajj Maktab B -2.webp";
import hajjP3MaktabB from "../hajj-2025-maktab-B/Polani Hajj Maktab B -3.webp";
import hajjP4MaktabB from "../hajj-2025-maktab-B/Polani Hajj Maktab B -4.webp";
import hajjP5MaktabB from "../hajj-2025-maktab-B/Polani Hajj Maktab B -5.webp";
import umrahP1 from "./ni/umrah-p1.jpg";
import umrahpackage from "./ni/umrahpackage.jpg";
import umrahbanner from "./ni/umrahpolani.png";
import hajjbanner from "./ni/hajjpolani.png";
import corporatetravel from "./ni/corporatetravel.jpg";
import relegioustravel from "./ni/relegioustravel.jpg";
import travelconsulting from "./ni/travelconsulting.jpg";
import visa from "./ni/visa.jpg";
import relegioustravelsmall from "./common/relegioustravelsmall.jpg";
import visasmall from "./common/visasmall.png";
import corporatetravelsmall from "./common/corporatetravelsmall.jpg";
import travelconsultingsmall from "./common/travelconsultingsmall.jpg";
import travelconsultinglarge from "./common/travelconsultinglarge.jpg";
import visalarge from "./common/visalarge.jpg";
import corporatetravellarge from "./common/corporatetravellarge.jpg";
import relegioustravellarge from "./common/relegioustravellarge.jpg";
import visasmalll from "./common/visasmalll.png";
import travelconsultingsmalll from "./common/travelconsultingsmalll.png";
import corporatetravelsmalll from "./common/corporatetravelsmalll.png";
import relegioustravelsmalll from "./common/relegioustravelsmalll.png";
import tourall from "./imagination/tourall.jpg";
import aboutsmall from "./imagination/aboutsmall.jpg";
import visaheadbanner from "./banner/visa.png";
import religioustravelheadbanner from "./banner/religioustravel.png";
import travelConsultingheadbanner from "./banner/travelconsulting.png";
import corporatetravelheadbanner from "./banner/corporatetravel.png";
import aboutusheadbanner from "./banner/aboutus.jpg";
import aboutussmallimg from "./banner/aboutussmall.png";
import aboutuslargee from "./banner/aboutuslarge.png";
import contact from "./banner/contact.jpg";
import umrahpackage1 from "./ni/umrahpackage1.jpg";
import umrahpackage2 from "./ni/umrahpackage2.jpg";
import umrahpackage3 from "./ni/umrahpackage3.jpg";
import polanibanner2 from "./ni/polaniban2.png";
import polanibanner3 from "./ni/polaniban3.png";
import polanibanner1 from "./ni/polaniban1.png";
import polanibanner4 from "./ni/10.webp";
import polanibanner5 from "./ni/11.webp";
import hajjP20262 from "./ni/hajj2026a2.jpg";
import hajjP20263 from "./ni/hajj2026a3.jpg";
import hajjP20264 from "./ni/hajj2026a4.jpg"; 
import hajjP20265 from "./ni/hajj2026a5.jpg";
import hajjP20266 from "./ni/hajj2026a6.jpg"; 
import hajjP20267 from "./ni/hajj2026a7.jpg"; 
import hajjP20268 from "./ni/hajj2026a8.jpg";

export const ImageConstants = {
  polanibanner1,
  polanibanner3,
  homeBanner1,
  homeBanner2,
  hajjInnerBanner,
  hajjInnerBanner2,
  hajjInnerBanner3,
  hajjInnerBanner4,
  InnerBanner,
  hajjP1,
  hajjP2,
  hajjP3,
  hajjP4,
  hajjP5,
  hajjP6,
  hajjP7,
  hajjP8,
  hajjP1MaktabB,
  hajjP2MaktabB,
  hajjP3MaktabB,
  hajjP4MaktabB,
  hajjP5MaktabB,
  umrahP1,
  umrahpackage,
  umrahbanner,
  hajjbanner,
  corporatetravel,
  relegioustravel,
  travelconsulting,
  visa,
  relegioustravelsmall,
  visasmall,
  corporatetravelsmall,
  travelconsultingsmall,
  visalarge,
  corporatetravellarge,
  relegioustravellarge,
  travelconsultinglarge,
  visasmalll,
  travelconsultingsmalll,
  corporatetravelsmalll,
  relegioustravelsmalll,
  tourall,
  aboutsmall,
  visaheadbanner,
  religioustravelheadbanner,
  travelConsultingheadbanner,
  corporatetravelheadbanner,
  aboutusheadbanner,
  aboutussmallimg,
  aboutuslargee,
  contact,
  umrahpackage1,
  umrahpackage2,
  umrahpackage3,
  polanibanner2,
  polanibanner4,
  polanibanner5,
  hajjP20262,
  hajjP20263,
  hajjP20264,
  hajjP20265,
  hajjP20266,
  hajjP20267,
  hajjP20268,
};
